import { useMemo, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import Button from "../../../../Core/Button/Button";
import Input from "../../../../Core/Fields/Floating/Input";
import DateField from "../../../../Core/Fields/Floating/Date";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import Textarea from "../../../../Core/Fields/Floating/Textarea";
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
import GetIcon from "../../../../utils/Icon";
import Tabs from "../../../../Components/Tabs";
import { FiPlus } from "react-icons/fi";
const statusOptions = [
  { label: "Draft", value: "Draft" },
  { label: "Accepted", value: "Accepted" },
  { label: "Rejected", value: "Rejected" },
];

const inspectionTypeOptions = [
  { label: "Incoming", value: "Incoming" },
  { label: "Outgoing", value: "Outgoing" },
  { label: "In Process", value: "In Process" },
];

const companyOptions = [
  { label: "Lakehawk Naturals", value: "Lakehawk Naturals" },
  { label: "Auric Labs Pvt Ltd", value: "Auric Labs Pvt Ltd" },
];

const referenceTypeOptions = [
  { label: "Sales Order", value: "Sales Order" },
  { label: "Purchase Order", value: "Purchase Order" },
  { label: "Delivery Note", value: "Delivery Note" },
];

const referenceNameOptions = [
  { label: "SO-00045", value: "SO-00045" },
  { label: "PO-00071", value: "PO-00071" },
  { label: "DN-00011", value: "DN-00011" },
];

const procedureOptions = [
  { label: "Manual Inspection", value: "Manual Inspection" },
  { label: "Automated Inspection", value: "Automated Inspection" },
  { label: "Sampling Inspection", value: "Sampling Inspection" },
];



const itemOptions = [
  { label: "MAT-GLASS-001", value: "MAT-GLASS-001" },
  { label: "MAT-GLASS-002", value: "MAT-GLASS-002" },
  { label: "MAT-GLASS-003", value: "MAT-GLASS-003" },
];

const readingStatusOptions = ["Accepted", "Pending", "Rejected"];

const readingDefaultRow = {
  parameter: "",
  status: "Accepted",
  numeric: false,
  value: "",
  reading1: "",
};

const AddQualityInspction = () => {
  const [activeTab, setActiveTab] = useState("general");
  const [formData, setFormData] = useState({
    general: {
      series: "MAT-QI-YYYY-",
      reportDate: new Date().toISOString().split("T")[0],
      status: "",
      inspectionType: "",
      referenceType: "",
      referenceName: "",
      company: "",
      qualityProcedure: "",
      manualInspection: true,
    },
    sample: {
      itemCode: "",
      itemSerialNo: "",
      batchNo: "",
      sampleSize: "0/3",
      description: "",
    },
    inspectors: {
      inspectedBy: "",
      verifiedBy: "",
    },
    remarks: "",
  });
  const [readings, setReadings] = useState([readingDefaultRow]);

  const generalFields = useMemo(
    () => [
      { key: "series",
         label: "Series", 
         extraclass: "removebottommargin",
         upperdivclass: "removebottommargin",
         type: "input",
          col: 4 },
      { key: "reportDate", label: "Report Date", type: "date", col: 4 },
      {
        key: "status",
        label: "Status",
        type: "select",
        options: statusOptions,
        col: 4,
      },
      {
        key: "inspectionType",
        label: "Inspection Type",
        type: "select",
        options: inspectionTypeOptions,
        col: 4,
      },
      {
        key: "company",
        label: "Company",
        type: "select",
        options: companyOptions,
        col: 4,
      },
      {
        key: "referenceType",
        label: "Reference Type",
        type: "select",
        options: referenceTypeOptions,
        col: 4,
      },
      {
        key: "referenceName",
        label: "Reference Name",
        type: "select",
        options: referenceNameOptions,
        col: 4,
      },
      {
        key: "qualityProcedure",
        label: "Quality Inspection",
        type: "select",
        options: procedureOptions,
        col: 4,
      },
      {
        key: "manualInspection",
        label: "Manual Inspection",
        type: "checkbox",
        col: 4,
        
      },
    ],
    []
  );

  const sampleFields = useMemo(
    () => [
      {
        key: "itemCode",
        label: "Item Code",
        type: "select",
        options: itemOptions,
      },
      { key: "itemSerialNo", label: "Item Serial No", type: "input" },
      { key: "batchNo", label: "Batch No", type: "input" },
      { key: "sampleSize", label: "Sample Size", type: "input" },
      { key: "description", label: "Description", type: "textarea" },
    ],
    []
  );

  const handleFormChange = (section, field, value) => {
    setFormData((prev) => {
      if (field === undefined) {
        return {
          ...prev,
          [section]: value,
        };
      }

      return {
        ...prev,
        [section]: {
          ...prev[section],
          [field]: value,
        },
      };
    });
  };

  const handleReadingChange = (index, field, value) => {
    setReadings((prev) =>
      prev.map((row, idx) =>
        idx === index
          ? {
              ...row,
              [field]: value,
            }
          : row
      )
    );
  };

  const handleAddReading = () => {
    setReadings((prev) => [...prev, { ...readingDefaultRow }]);
  };

  const handleRemoveReading = (index) => {
    if (readings.length === 1) return;
    setReadings((prev) => prev.filter((_, idx) => idx !== index));
  };

  const handleSave = () => {
    console.log("Save Quality Inspection", { formData, readings });
  };

  const handleSubmit = () => {
    console.log("Submit Quality Inspection", { formData, readings });
  };

  const renderField = (field) => {
    const value = formData.general[field.key];
    if (field.type === "date") {
      return (
        <DateField
          id={field.key}
          label={field.label}
          value={value}
          onChange={(e) =>
            handleFormChange("general", field.key, e.target.value)
          }
        />
      );
    }

    if (field.type === "select") {
      return (
        <SelectSearch
          label={field.label}
          list={field.options}
          value={value}
          onChange={(val) => handleFormChange("general", field.key, val)}
        />
      );
    }

    if (field.type === "checkbox") {
      return (
        <div
          className="d-flex align-items-center"
          style={{ marginTop: "25px" }}
        >
          <Checkbox
            id={field.key}
            label={field.label}
            value={Boolean(value)}
            onChange={(checked) =>
              handleFormChange("general", field.key, checked)
            }
          />
        </div>
      );
    }

    return (
      <Input
        id={field.key}
        label={field.label}sss
        value={value}
        extraclass={field.extraclass}
        divclass={field.upperdivclass}
        onChange={(e) => handleFormChange("general", field.key, e.target.value)}
        style={{ height: "30px" }}
      />
    );
  };

  const renderSampleField = (field) => {
    const value = formData.sample[field.key];
    if (field.type === "select") {
      return (
        <SelectSearch
          label={field.label}
          list={field.options}
          value={value}
          onChange={(val) => handleFormChange("sample", field.key, val)}
        />
      );
    }

    if (field.type === "textarea") {
      return (
        <Textarea
          id={field.key}
          label={field.label}
          value={value}
          onChange={(e) =>
            handleFormChange("sample", field.key, e.target.value)
          }
          style={{ minHeight: "90px" }}
        />
      );
    }

    return (
      <Input
        id={field.key}
        label={field.label}
        value={value}
        onChange={(e) => handleFormChange("sample", field.key, e.target.value)}
        style={{ height: "30px" }}
      />
    );
  };

  const actionButtons = (
    <>
      <Button
        className="btnsecond border-0 d-flex"
        iconName="MdOutlineSaveAlt"
        style={{ gap: "4px", height: "28px" }}
        onClick={handleSave}
      >
        Save Draft
      </Button>
      <Button
        className="custom-btn-00989 d-flex"
        iconName="LuFilePlus2"
        style={{ gap: "4px", height: "28px" }}
        onClick={handleSubmit}
      >
        Submit
      </Button>
    </>
  );

  return (
    <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
      <Helmet>
        <title>Quality Inspection - Create</title>
      </Helmet>
      <Header />
      <div
        className="container-fluid maindiv d-flex flex-column"
        style={{ flexGrow: 1 }}
      >
        <FormLayoutTwo
          title={
            <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              New Quality Inspection  
           
            </span>
          }
          breadcrumbs={[
            { label: "Quality Inspection" },
            {
              label: "Quality Inspection List",
              url: "/master/quality-inspection/main-list",
            },
          ]}
          status="New"
          actionButtons={actionButtons}
        >
          <div style={{ width: "100%", backgroundColor: "#fff", flexGrow: 1 }}>
            <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
              <div className="d-flex justify-content-between align-items-end">
                <ul className="nav nav-tabs" style={{ border: "none" }}>
                  <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                    <a
                      className={
                        activeTab === "general"
                          ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                          : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                      }
                      onClick={() => setActiveTab("general")}
                      href="javascript:void(0);"
                    >
                      General Details
                      {activeTab === "general" ? (
                        <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                      ) : (
                        <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                      )}
                    </a>
                  </li>
                </ul>
                <div
                  className="d-flex align-items-center mb-2 px-3"
                  style={{ gap: "4px", fontSize: "12px" }}
                >
                  <span style={{ position: "relative", top: "-1px" }}>
                    <GetIcon
                      className="text-[#4B002B]"
                      iconName="CgAttachment"
                      size={12}
                    />
                  </span>
                  <span className="fw-semibold" style={{ color: "#4B002B" }}>
                    Attachments
                  </span>
                </div>
              </div>
            </div>

            {activeTab === "general" && (
              <div className="p-3" style={{ backgroundColor: "#fff" }}>
               <div className="row g-3">
  {/* LEFT BOX */}
  <div className="col-xl-6">
    <div
      className="p-3 h-[400px]"
      style={{
        backgroundColor: "#EBE6FA",
        borderRadius: "8px",
      }}
    >
      <p className="fw-semibold mb-3" style={{ color: "#4B002B" }}>
        General Details
      </p>

      <div className="row g-3 remove-bottom-space">
       {generalFields.map((field) => (
         <div key={field.key} className={`col-md-${field.col || 6}`}>
      <div className="p-0 m-0" style={{ width: "100%" }}>
        <div style={{ marginBottom: 0 }}>
          {renderField(field)}
        </div>
      </div>
    </div>
  ))}
</div>

    </div>
  </div>

  {/* RIGHT BOX */}
  <div className="col-xl-6">
    <div
      className="p-3 h-[400px]"
      style={{
        backgroundColor: "#E8F7E8",
        borderRadius: "8px",
      }}
    >
      <p className="fw-semibold mb-3" style={{ color: "black" }}>
        Item Details
      </p>

      <div className="row g-3">

{/* FIRST ROW — 3 INPUTS */}
{sampleFields.slice(0, 3).map((field) => (
  <div key={field.key} className="col-md-4">
    {renderSampleField(field)}
  </div>
))}

{/* SECOND ROW — 2 INPUTS */}
{sampleFields.slice(3).map((field) => (
  <div key={field.key} className="col-md-6">
    {renderSampleField(field)}
  </div>
))}

</div>

    </div>
  </div>
</div>


                <div
                  className="mt-3 p-3"
                  style={{
                    backgroundColor: "#F8F9FC",
                    borderRadius: "8px",
                    border: "1px solid #E0E4F0",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <p
                        className="fw-semibold mb-0"
                        style={{ color: "#4B002B" }}
                      >
                        Readings
                      </p>
                      <small className="text-muted">
                        Capture measurements as per the sample
                      </small>
                    </div>
                   
                  </div>
                  
                  <div className="table-responsive">
                    <table className="table table-bordered mb-0">
                      <thead className="table-light">
                        <tr>
                          <th style={{ width: "50px" }}>#</th>
                          <th>Parameter</th>
                          <th>Status</th>
                          <th style={{ width: "100px" }}>Numeric</th>
                          <th>Reading Value</th>
                          <th>Reading 1</th>
                          <th style={{ width: "60px" }} />
                        </tr>
                      </thead>
                      <tbody>
                        {readings.map((row, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              <input
                                className="form-control form-control-sm"
                                value={row.parameter}
                                onChange={(e) =>
                                  handleReadingChange(
                                    index,
                                    "parameter",
                                    e.target.value
                                  )
                                }
                                placeholder="Parameter"
                              />
                            </td>
                            <td>
                              <select
                                className="form-select form-select-sm"
                                value={row.status}
                                onChange={(e) =>
                                  handleReadingChange(
                                    index,
                                    "status",
                                    e.target.value
                                  )
                                }
                              >
                                {readingStatusOptions.map((status) => (
                                  <option key={status} value={status}>
                                    {status}
                                  </option>
                                ))}
                              </select>
                            </td>
                            <td className="text-center">
                              <input
                                type="checkbox"
                                className="form-check-input mt-0"
                                checked={row.numeric}
                                onChange={(e) =>
                                  handleReadingChange(
                                    index,
                                    "numeric",
                                    e.target.checked
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                className="form-control form-control-sm"
                                value={row.value}
                                onChange={(e) =>
                                  handleReadingChange(
                                    index,
                                    "value",
                                    e.target.value
                                  )
                                }
                                placeholder="Reading Value"
                              />
                            </td>
                            <td>
                              <input
                                className="form-control form-control-sm"
                                value={row.reading1}
                                onChange={(e) =>
                                  handleReadingChange(
                                    index,
                                    "reading1",
                                    e.target.value
                                  )
                                }
                                placeholder="Reading 1"
                              />
                            </td>
                            <td className="text-center">
                              <button
                                type="button"
                                className="btn btn-link p-0 text-danger"
                                onClick={() => handleRemoveReading(index)}
                                disabled={readings.length === 1}
                              >
                                <GetIcon iconName="MdDeleteForever" size={18} />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                   

                    <Button
  className="btnthird border-0 d-flex"
  style={{
    // fontFamily: "Poppins",
    width: "80px",
    height: "28px",
    background: "#BE849D",
    borderRadius: "4px",
    gap: "5px",
    padding: "5px 7px",
    opacity: 1,
    rotate: "0deg",
    marginTop: "10px",
    alignItems: "center",
  }}
  onClick={handleAddReading}
>
  <span
    style={{
      background: "#F6D593",

      width: "10px",
      height: "10px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    }}
  >
    <FiPlus size={10} color="white" width="6px" height="6px" />
  </span>
  <span style={{ fontSize: "11px", fontWeight: 500 }}>Add Row</span>
</Button>
                         

                  </div>
                </div>

                <div className="row justify-content-center mt-3">


                <div className="row mt-3">
  <div className="col-lg-7">  {/* now left-aligned */}
    <div
      className="p-3"
      style={{
        backgroundColor: "#FDEEF4",
        borderRadius: "8px",
      }}
    >
      <p
        className="fw-semibold mb-3"
        style={{ color: "#7A1D3A",
          fontSize:"20px"
         }}
      >
        Inspected By
      </p>

      <div className="row g-3">

  {/* FIRST ROW — SIDE BY SIDE INPUTS */}
  <div className="col-md-6">
    <Input
      id="inspectedBy"
      label="Inspected By"
      divclass="mb-0"
      value={formData.inspectors.inspectedBy}
      onChange={(e) =>
        handleFormChange("inspectors", "inspectedBy", e.target.value)
      }
      style={{ 
        height: "34px",
        fontSize: "15px"       // input font size
      }}
      labelStyle={{
        fontSize: "15px",
        fontWeight: "600"     // bold label
      }}
    />
  </div>

  <div className="col-md-6">
    <Input
      id="verifiedBy"
      label="Verified By"
      divclass="mb-0"
      value={formData.inspectors.verifiedBy}
      onChange={(e) =>
        handleFormChange("inspectors", "verifiedBy", e.target.value)
      }
      style={{ 
        height: "34px",
        fontSize: "15px"
      }}
      labelStyle={{
        fontSize: "15px",
        fontWeight: "600"
      }}
    />
  </div>

  {/* SECOND ROW — FULL WIDTH TEXTAREA */}
  <div className="col-12">
    <Textarea
      id="remarks"
      label="Remarks"
      value={formData.remarks}
      onChange={(e) =>
        handleFormChange("remarks", undefined, e.target.value)
      }
      style={{
        minHeight: "120px",
        width: "400px",
        fontSize: "25px"        // textarea text size
      }}
      labelStyle={{
        fontSize: "15px",
        fontWeight: "600"
      }}
    />
  </div>

</div>

    </div>
  </div>
</div>

</div>

              </div>
            )}
          </div>
        </FormLayoutTwo>
      </div>
    </div>
  );
};

export default AddQualityInspction;
